import LoginSignup from "../../Components/Login/LoginSignup";
import "../../Components/Login/LoginSignup.css";


const LoginPage = () => {
  return (
    <div className="login-page">
  <LoginSignup/>
    </div>
  );
};

export default LoginPage;